import { useQueryErrorResetBoundary } from '@tanstack/react-query';
import GlobalErrorBoundaryFallback from 'components/GlobalErrorBoundaryFallback';
import datadogActions from 'lib/datadog';
import type { FC, PropsWithChildren } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

const GlobalErrorBoundary: FC<PropsWithChildren> = ({ children }) => {
  const { reset } = useQueryErrorResetBoundary();

  return (
    <ErrorBoundary
      onReset={reset}
      onError={(error) => {
        datadogActions.trackDatadogError(error, {
          source: 'global_error_boundary',
        });
      }}
      FallbackComponent={GlobalErrorBoundaryFallback}
    >
      {children}
    </ErrorBoundary>
  );
};

export default GlobalErrorBoundary;
